export enum ECallStatus {
  PENDING = 'PENDING',
  RINGING_IN = 'RINGING_IN',
  RINGING_OUT = 'RINGING_OUT',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
}

export enum ESessionStatus {
  INIT = 'INIT',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  ENDED = 'ENDED',
  REJECTED = 'REJECTED',
  COMPLETED = 'COMPLETED',
  ACCEPTED = 'ACCEPTED',
  ENDED_BY_BLIND_TRANSFER = 'ENDED_BY_BLIND_TRANSFER',
}
